import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AppLoader from './AppLoader';
import NotFound from './components/NotFound';
import Theme, { GlobalStyles } from './Theme';
import { SnackbarComponent } from './common/components/SnackbarUtilsConfigurator';

const OpenRoles = lazy(() => import('./pages/OpenRolesPage'));
const SingleRole = lazy(() => import('./pages/SingleRole'));

function App() {
  return (
    <Suspense fallback={<AppLoader />}>
      <Theme>
        <GlobalStyles />
        <Routes>
          <Route path='/' element={<Navigate to='/roles' />} />
          <Route path='/roles' element={<OpenRoles />} />
          <Route path='/roles/:id' element={<SingleRole />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
        <SnackbarComponent />
      </Theme>
    </Suspense>
  );
}

export default App;
